import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatIsASpecialSupplementalNeedsTrustPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-is-a-special-supplemental-needs-trust/']} />;
}
